import { useRef } from "react"
import FilterProvider from './(context)/filter'
import OverviewTable from "./(components)/overview-table";
import CreateMatch from "@/components/features/matches/create-match";
import { useQueryClient } from "@tanstack/react-query";
import { hasRight } from "@/config/rights.config";
import { useAuth } from "@/hooks/use-auth";
import { Button } from "@/components/ui/button";
import * as Icons from 'lucide-react';
import Filter from "./(components)/filter";
import { Separator } from "@/components/ui/separator";

const MatchesPage = () => {
    const refetchRef = useRef<() => void | null>(null);
    const { user } = useAuth();
    const queryClient = useQueryClient();

    return (
        <div className='p-4 space-y-4 h-full flex flex-col justify-between overflow-auto'>
            <header>
                <h1 className='text-3xl font-bold'>Match databank</h1>
            </header>
            <div className='flex items-center justify-between gap-4'>

                <Filter
                    onSearch={() => refetchRef.current?.()}
                />
            </div>

            <OverviewTable onRefetchReady={(refetch) => (refetchRef.current = refetch)} />
        </div>
    )
}

export default () => {
    return (
        <FilterProvider>
            <MatchesPage />
        </FilterProvider>
    )
}